import React from 'react';

const RelatedServices = ({ currentService }) => {
  const services = [
    { name: 'Plumbers', path: '/plumbers', description: 'Emergency repairs & installations' },
    { name: 'Electricians', path: '/electricians', description: 'Electrical repairs & installations' },
    { name: 'HVAC', path: '/hvac', description: 'Heating & cooling services' },
    { name: 'Locksmiths', path: '/locksmiths', description: 'Emergency lockout services' },
    { name: 'Contractors', path: '/contractors', description: 'Home improvement projects' },
    { name: 'Roofers', path: '/roofers', description: 'Roof repairs & installations' },
    { name: 'Landscapers', path: '/landscapers', description: 'Lawn care & landscaping' },
    { name: 'Real Estate', path: '/realestate', description: 'Property sales & rentals' },
    { name: 'Tax Prep', path: '/taxprep', description: 'Tax preparation services' },
    { name: 'Cleaning', path: '/cleaning', description: 'Residential & commercial cleaning' },
    { name: 'Auto Repair', path: '/autorepair', description: 'Car repairs & maintenance' },
    { name: 'Law Firms', path: '/lawfirms', description: 'Legal consultations & services' },
    { name: 'Medical', path: '/medical', description: 'Healthcare & dental practices' },
    { name: 'Insurance', path: '/insurance', description: 'Insurance quotes & claims' },
    { name: 'Med Spas', path: '/medspa', description: 'Botox, facials & aesthetic treatments' },
    { name: 'Nail Salons', path: '/nailsalon', description: 'Manicures, pedicures & nail art' },
    { name: 'Hair Salons', path: '/hairsalon', description: 'Cuts, color & styling services' },
    { name: 'Veterinarians', path: '/veterinarian', description: 'Pet care & veterinary services' },
    { name: 'Therapists', path: '/therapist', description: 'Mental health & counseling services' },
    { name: 'Massage Therapy', path: '/massage', description: 'Therapeutic & relaxation massage' },
    { name: 'Chiropractors', path: '/chiropractor', description: 'Spinal adjustments & pain relief' },
    { name: 'Dentists', path: '/dentist', description: 'Dental care & oral health services' },
    { name: 'Physical Therapy', path: '/physicaltherapy', description: 'Rehabilitation & movement therapy' },
    { name: 'Fitness Training', path: '/fitness', description: 'Personal training & fitness coaching' }
  ];

  // Filter out current service and get random 6 related services
  const relatedServices = services
    .filter(service => service.path !== currentService)
    .sort(() => Math.random() - 0.5)
    .slice(0, 6);

  return (
    <section className="py-16 px-6 bg-gray-50">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-2xl lg:text-3xl font-black mb-8 text-center text-gray-900">
          AI Receptionist for <span className="text-blue-900">Other Industries</span>
        </h2>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {relatedServices.map((service, index) => (
            <a
              key={index}
              href={service.path}
              className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100 hover:border-blue-200 group"
            >
              <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-blue-900 transition-colors">
                {service.name}
              </h3>
              <p className="text-gray-600 text-sm mb-4">
                {service.description}
              </p>
              <div className="text-blue-600 text-sm font-semibold group-hover:text-blue-700">
                Get AI receptionist →
              </div>
            </a>
          ))}
        </div>
        
        <div className="text-center mt-8">
          <a
            href="/industries"
            className="text-blue-600 hover:text-blue-700 font-semibold"
          >
            See all industries →
          </a>
        </div>
      </div>
    </section>
  );
};

export default RelatedServices;